export default "__VITE_ASSET__MKCvQViC__"